[
  {
    "id": "SR-M6-PANNEN-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "meervoud",
    "familyId": "SR-MEERVOUD-KORTE-KLANK",
    "conceptId": "plural_short_vowel_doubling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het meervoud van 'pan'?",
    "options": ["pannen", "panen", "pansen", "pannon"],
    "correctAnswer": 0,
    "explanation": "Korte klinker ('a' in pan) → dubbele medeklinker in het meervoud: pan-nen. Als je maar één 'n' schrijft (pa-nen), wordt de 'a' lang.",
    "distractorExplanations": {
      "1": "Met één 'n' (pa-nen) zou de 'a' lang klinken. De 'a' is kort, dus dubbele 'n'.",
      "2": "'-sen' is geen correct meervoudsuitgang voor dit woord.",
      "3": "'-on' is geen Nederlandse meervoudsuitgang."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Korte Klinker Regel",
        "content": "Korte klinker (pan, kat, pit) → dubbele medeklinker in meervoud (pannen, katten, pitten)",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6-GEVAARLIJK-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "klanken_spelling",
    "subSkill": "algemeen",
    "familyId": "SR-UITGANG-LIJK",
    "conceptId": "suffix_lijk_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed gespeld?",
    "options": ["gevaarlijk", "gevaarluk", "gevaarlek", "gevaarelijk"],
    "correctAnswer": 0,
    "explanation": "Woorden op '-lijk' klinken als 'luk', maar je schrijft altijd '-lijk'. Andere voorbeelden: heerlijk, moeilijk, eerlijk.",
    "distractorExplanations": {
      "1": "Je hoort 'luk', maar de spellingregel zegt: schrijf '-lijk'.",
      "2": "'-lek' is geen correcte uitgang. Het is '-lijk'.",
      "3": "Er zit geen extra 'e' tussen 'gevaar' en 'lijk'."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "-lijk Regel",
        "content": "Woorden op -lijk klinken als 'luk', maar je schrijft altijd -lijk (gevaarlijk, heerlijk, moeilijk)",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6-CAFE-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-ACCENT-CAFE",
    "conceptId": "accent_aigu_loanword",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed gespeld?",
    "options": ["café", "cafe", "cafee", "cafè"],
    "correctAnswer": 0,
    "explanation": "'Café' is een Frans leenwoord met een accent aigu (é). Dit moet je uit je hoofd leren. Zonder accent is het fout.",
    "distractorExplanations": {
      "1": "Zonder accent is het fout. 'Café' schrijf je altijd met é.",
      "2": "Twee e's is fout. Het is café met één é.",
      "3": "Dit is een accent grave (è). Café heeft een accent aigu (é) — het streepje gaat naar rechts."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Weetwoorden met é",
        "content": "Sommige Franse leenwoorden schrijf je met é (accent aigu): café. Let op: idee heeft géén accent!",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6-IDEE-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-ACCENT-IDEE",
    "conceptId": "accent_aigu_loanword",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed gespeld?",
    "options": ["idee", "idé", "idée", "ide"],
    "correctAnswer": 0,
    "explanation": "'Idee' schrijf je zonder accent — gewoon met twee e's. Alleen 'café' heeft een accent aigu.",
    "distractorExplanations": {
      "1": "'Idee' heeft geen accent. Alleen café heeft é.",
      "2": "Dit is de oude spelling. In modern Nederlands schrijven we gewoon 'idee'.",
      "3": "Te weinig letters. Het is 'idee' met twee e's."
    }
  },
  {
    "id": "SR-M6-KOFFIE-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_accent",
    "familyId": "SR-WEETWOORD-IE-UITGANG",
    "conceptId": "ie_ending_loanword",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Vul in: Ik drink een kop koffi... in het café.",
    "options": ["koffie", "koffi", "koffé", "koffy"],
    "correctAnswer": 0,
    "explanation": "'Koffie' schrijf je met '-ie' aan het eind. Dit is een weetwoord — geen accent nodig.",
    "distractorExplanations": {
      "1": "Zonder '-e' is het fout. Het is 'koffie', niet 'koffi'.",
      "2": "'Koffie' heeft geen accent. Alleen 'café' heeft een é.",
      "3": "In het Nederlands schrijven we '-ie', niet '-y'."
    }
  },
  {
    "id": "SR-M6-CADEAU-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-CADEAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed gespeld?",
    "options": ["cadeau", "cado", "kadeau", "kado"],
    "correctAnswer": 0,
    "explanation": "'Cadeau' is een Frans leenwoord met '-eau'. Het begint met 'c' en eindigt op '-eau'. Dit moet je uit je hoofd leren.",
    "distractorExplanations": {
      "1": "'Cado' is spreektaal. De standaardspelling is 'cadeau'.",
      "2": "Het begint met 'c', niet met 'k'.",
      "3": "'Kado' is spreektaal en begint met de verkeerde letter."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Weetwoorden met -eau",
        "content": "Franse leenwoorden met -eau: cadeau, bureau, niveau. Je hoort 'o', maar schrijft 'eau'.",
        "icon": "book"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "SR-M6-BUREAU-V01",
    "module": "SpellingRegel",
    "difficulty": 103,
    "difficultyTier": 3,
    "levelCode": "M6",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-BUREAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 5,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed gespeld?",
    "options": ["bureau", "buro", "bureu", "buroo"],
    "correctAnswer": 0,
    "explanation": "'Bureau' is een Frans leenwoord met '-eau'. Net als cadeau en niveau.",
    "distractorExplanations": {
      "1": "'Buro' is spreektaal. De standaardspelling is 'bureau'.",
      "2": "De uitgang is '-eau', niet '-eu'. Er ontbreekt een 'a'.",
      "3": "De uitgang is '-eau', niet '-oo'."
    }
  }
]